(function(){
    let container = document.querySelector(".quiz");
    if (container) {
        let id = container.dataset.id;
        let key = `quiz-${id}`;
        if (localStorage.getItem(key) == null) {
            const delay = typeof container.dataset.delay !== "undefined" ? parseInt(container.dataset.delay)  : 5000;
            setTimeout(() => {
                container.classList.add('quiz_shown');
            }, delay);

            container.addEventListener('click', (e) => {
                if (e.target.classList.contains('quiz__close')) {
                    container.classList.remove('quiz_shown');
                    localStorage.setItem(key, 1);
                }
            })
        }   
    }
})();